<template>
  <div class="container float-container">
    <div class="autoselect-options-container">
      <!-- Muestra opciones cuando drop-down está activo -->
      <div v-if="showDropdown" class="autoselect-options">
        <div v-for="option in filteredOptions" :key="option.value">
          <span
            class="autoselect__option"
            @click="onOptionClick(option.label)"
            :title="option.label"
          >
            {{ `${option.label}` }}
          </span>
        </div>
      </div>
      <img
        class="caret"
        v-if="showCaret"
        @click="toggleDropdown"
        :src="caret"
        alt="caret"
      />
    </div>
    <text-input
      ref="textInput"
      class="text-input"
      :hint="subhint"
      :label="label"
      :name="name"
      :value="selectedValue"
      :required="required"
      :subhint="subhint"
      :validationError="validationError"
      @input="onInput"
      @onFocus="onFocus"
      @onBlur="onBlur"
      @click="$emit('click')"
      :quantumObfuscate="quantumObfuscate"
    />
  </div>
</template>

<script>
import TextInput from "@/components/core/TextInput";
export default {
  name: "CustomSearchSelector",
  components: { TextInput },
  props: {
    name: {
      type: String,
      default: "selector"
    },
    label: {
      type: String,
      default: "label"
    },
    items: {
      type: Array,
      default: new Array()
    },
    value: String,
    subhint: String,
    validationError: String,
    quantumObfuscate: Boolean
  },
  data() {
    return {
      focused: false,
      internalValue: this.value,
      forceShowDropdown: false,
      caret: require("@/assets/img/1x/arrow-simple-down.svg")
    };
  },
  computed: {
    options() {
      return this.items.map(e => {
        return {
          label: e.label || e,
          value: e.value || e
        };
      });
    },
    showDropdown() {
      return (
        this.forceShowDropdown ||
        (this.focused && this.filteredOptions.length !== this.options.length)
      );
    },
    showCaret() {
      return !this.internalValue;
    },
    filteredOptions() {
      let input = this.internalValue
        ? (this.internalValue + "").trim().toLowerCase()
        : "";

      return !input
        ? this.options
        : this.options.filter(opt => opt.label.toLowerCase().includes(input));
    },
    selectedValue() {
      if (this.focused) {
        return this.internalValue;
      }
      return this.options.find(opt => opt.label === this.internalValue)?.label;
    }
  },
  methods: {
    onInput(val) {
      this.internalValue = val;
    },
    onFocus() {
      this.focused = true;
    },
    onBlur() {
      setTimeout(() => {
        // Dar tiempo al select a poner el value
        this.focused = false;
        this.internalValue = this.selectedValue ?? "";
        this.$emit("input", this.selectedValue ?? "");
      }, 230);
    },
    onOptionClick(val) {
      this.$emit("input", val);
      this.internalValue = val;
      this.forceShowDropdown = false;
    },
    toggleDropdown() {
      this.forceShowDropdown = !this.forceShowDropdown;
      if (this.forceShowDropdown) {
        this.$refs.textInput._focus();
      }
    }
  },
  watch: {
    internalValue(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.internalValue = newValue;
      }
    },
    value(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.internalValue = newValue;
      }
    }
  }
};
</script>

<style scoped>
.autoselect-options-container {
  position: relative;
}

.autoselect-options-container .caret {
  position: absolute;
  right: 0;
  top: 0;
  /* El borde es para agrandar el area clickeable */
  border-right: 16px solid transparent;
  border-top: 18px solid transparent;
  border-bottom: 18px solid transparent;
  cursor: pointer;
  z-index: 10;
}

.autoselect-options {
  position: absolute;
  z-index: 11;
  left: 0;
  right: 0;
  top: 56px; /* Alto inputs */
  background: white;
  max-height: 250px;
  overflow-x: hidden;
  overflow-y: auto;
  box-shadow: 0 0 5px 0px rgba(0, 0, 0, 0.2);
}

.autoselect__option {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 16px 0;
  border-bottom: 1px solid #bdbdbd;
  font-family: "BentonSansBBVA-Light", Helvetica, Arial, sans-serif;
  cursor: pointer;
}

.autoselect-options div {
  padding: 0 16px;
}
.autoselect-options div:hover {
  background-color: #eeeeee;
}

.autoselect-options div:last-child span {
  border-bottom: 0;
}

.autoselect-options span:hover {
  color: #000;
}

.secondary {
  font-size: 0.8em;
}
</style>
